// extracted by mini-css-extract-plugin
export default {"title":"ForgotPassword_title__wS+1p","controls":"ForgotPassword_controls__XXdyC","control":"ForgotPassword_control__QoC++"};